import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessageWrappedInSpan } from '../../misc';

import { PrimaryButton } from '../../misc/Buttons';
import FormattedPrice from '../../misc/FormattedPrice';

function CartQuickCheckout(props) {
  return (
    <div className="cart-quick-checkout-container">
      <div>
        <p>
          <span className="cart-quick-checkout-title">
            <FormattedMessageWrappedInSpan id="cartQuickCheckout.title" defaultMessage="Cart" />
          </span>
          <FormattedMessageWrappedInSpan
            id="cartQuickCheckout.itemsCount"
            defaultMessage="({count, plural, one {# Item} other {# Items}})"
            values={{ count: props.cart.lineItems.length }}
          />
        </p>
        <p className="cart-quick-checkout-price">
          <FormattedPrice price={props.cart.totalPrice} />
        </p>
      </div>
      <PrimaryButton
        leftLabel={
          <FormattedMessageWrappedInSpan
            id="cartQuickCheckout.buttonLabel"
            defaultMessage="Checkout"
          />
        }
        onClick={props.onCheckoutClick}
      />
    </div>
  );
}

CartQuickCheckout.propTypes = {
  onCheckoutClick: PropTypes.func,

  // Relay props
  cart: PropTypes.object,
};

export default createFragmentContainer(CartQuickCheckout, {
  cart: graphql`
    fragment CartQuickCheckout_cart on Cart {
      lineItems {
        __typename
      }
      totalPrice
    }
  `,
});
